var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},_vm._l((_vm.value),function(item,index){return _c('li',{key:index,staticClass:"list-group-item bg-light-danger"},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }